export const formatNumberForAPI = (field) => {
  if (typeof field === 'number') return field;
  if (typeof field !== 'string') return undefined;
  if (isNaN(field) || isNaN(parseFloat(field))) return undefined;
  return Number(field);
};

export const formatBooleanForAPI = (field) => {
  if (typeof field === 'boolean') return field;
  if (field === undefined || field === null) return undefined;
  // If field is a number or numeric string, return false for 0 and true for everything else
  if (!isNaN(field) || !isNaN(parseFloat(field))) return !!field;
  return undefined;
};
